import Vue from 'vue';
import VueEventBus from '@/services/eventBus/VueEventBus';
import EventBus from '@/services/eventBus/EventBus';

const eventBus: EventBus = new VueEventBus(
  new Vue()
);

export default eventBus;